<template>
  <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
      <div class="main-navbar">
        <nav class="navbar align-items-stretch navbar-light bg-white flex-md-nowrap border-bottom p-0">
          <a class="navbar-brand w-100 mr-0" @click.prevent="$router.push({name: 'dashboard'})" href="#" style="line-height: 25px;">
            <div class="d-table m-auto">
              <img id="main-logo" class="d-inline-block align-top mr-1" style="max-width: 40px;margin-top: -4px;" src="@/assets/images/kf-logo.png" alt="Konsorcjum Finansowe">
              <!--<span v-if="!hideLogoText" class="d-none d-md-inline ml-1">Konsorcjum Finansowe</span>-->
            </div>
          </a>
          <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none" @click="handleToggleSidebar()">
            <i class="material-icons">&#xE5C4;</i>
          </a>
        </nav>
      </div>

      <form action="#" class="main-sidebar__search w-100 border-right d-sm-flex d-md-none d-lg-none">
        <div class="input-group input-group-seamless ml-3">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i class="fas fa-search"></i>
            </div>
          </div>
          <input class="navbar-search form-control" type="text" placeholder="Search for something..." aria-label="Search">
        </div>
      </form>

      <div class="nav-wrapper">
          <d-nav class="flex-column">
            <li style="overflow: visible;" v-for="(item, navItemIdx) in items" :key="navItemIdx" class="nav-item dropdown" v-if="viableItem(item)">
              <d-link style="overflow: visible;" :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']" :to="item.to" v-d-toggle="`snc-${navItemIdx}`">
                <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore" />
                <span v-if="item.title">{{ item.title }}</span>
                  <div class="sidebar-info-items-wrapper">
                      <ss-popover  v-if="item.title === 'Umowy' && unaccepted_contracts_number" variant="left" class="terminated-info">
                          <span class="exclamation bg-black">{{ unaccepted_contracts_number }}</span>
                          <template slot="tooltip">Liczba niezaakceptowanych umów</template>
                      </ss-popover>
                  </div>
                <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter" />
              </d-link>
              <d-collapse v-if="item.items && item.items.length" :id="`snc-${navItemIdx}`" class="dropdown-menu dropdown-menu-small" accordion="sidebar-items-accordion">
                <d-dropdown-item v-for="(subItem, subItemIdx) in item.items" :key="subItemIdx" :href="subItem.href" :to="subItem.to">
                  {{ subItem.title }}
                </d-dropdown-item>
              </d-collapse>
            </li>
          </d-nav>
      </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'
import store from "@/store";

export default {
  name: 'main-sidebar',

  props: {
    /**
      * Whether to hide the logo text, or not.
      */
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: true,
    },
  },
  computed:{
    ...mapGetters([
      'getUser'
    ])
  },
  data() {
    return {
        sidebarVisible: false,
        interval:   null,
        unaccepted_contracts_number: null
    };
  },
  created() {
    this.$eventHub.$on('toggle-sidebar', this.handleToggleSidebar);
    this.unacceptedContracts();
    this.interval = setInterval(() => {
        this.unacceptedContracts();
    }, (1000 * 60 * 5));
  },
  beforeDestroy() {
    this.$eventHub.$off('toggle-sidebar');
    clearInterval(this.interval);
  },

  methods: {
    viableItem(item){
      if(item.to.name === 'holidays' && this.getUser.is_admin !== 1) {
        return false
      }
      if(this.getUser.is_admin === 2){
          if(!store.getters.getShortAccessModules.includes(item.to.name)){
              return false;
          }
      }
      return true
    },
    unacceptedContracts (){
      axios.post('api/schedules/get-not-accepted-schedules-number',
          {},
          { headers: {"Authorization": 'Bearer ' + window.localStorage.getItem('token')} }
      ).then(response =>{
          this.unaccepted_contracts_number = response.data.not_accepted_contracts_number;
      });
    },
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
  },
};
</script>

<style lang="scss">
  .main-sidebar {
    .item-icon-wrapper {
      display: inline-block;
    }
    .dropdown-menu {
      display: block;
    }
    .terminated-info{
        position: relative;
        top: 0;
        left: 0;
        width: auto;

        .exclamation{
            padding: 2px 4px;
            min-width: 20px;
            display: block;
            text-align: center;
            color: white;
        }
    }

      .bg-black{
          background-color: black;
      }
      .has-popover .ss-popover{
          min-width: 220px;
          white-space: normal;
      }
      .sidebar-info-items-wrapper{
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 50%;
          right: 15px;
          -webkit-transform: translate(0, -50%);
          -moz-transform: translate(0, -50%);
          -ms-transform: translate(0, -50%);
          -o-transform: translate(0, -50%);
          transform: translate(0, -50%);
          & > span{
              margin-left: 5px;
          }
      }
  }
</style>
